import "airbnb-js-shims/target/es2015";
import "airbnb-browser-shims/browser-only";

import React from 'react';
import ReactDOM from 'react-dom';
import thunk from 'redux-thunk';
import logger from 'redux-logger';
import { merge } from 'lodash';

import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import "broadcastchannel-polyfill";
import "hermes";
import './utils/closestPolyfill';

import ChatApp from './reducers/index';
import App from './app';
import { addMessages, scrollToBottom } from './actions/chat-body';
import { streamMessageMiddleware } from './middlewares/stream-message';
import { initApp, initProtocol, updateBottomButtons, handleChatRoomConnection, setDefaultSystemMessages, updateSystemMessages, updateTitle, updatePlaceholder } from './actions/chat-root';
import { sendMessage, postMessage, showWait, hideWait, appendMessages } from './actions/input-field';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  ChatApp,
  composeEnhancers(applyMiddleware(thunk, streamMessageMiddleware))
);

function render(rootElement, mode) {
  ReactDOM.render(
    <Provider store={store}>
      <App mode={mode} />
    </Provider>,
    rootElement
  );

  if (module.hot) {
    module.hot.accept('./app', () => {
      const NextApp = require('./app').default;
      ReactDOM.render(
        <Provider store={store}>
          <NextApp mode={mode} />
        </Provider>,
        rootElement
      );
    });
  }
}

const cu = window.cu || {};
cu.web_plugin = merge(cu.web_plugin, {
  initApp: function (element, mode, option) {
    store.dispatch(initApp(option));
    render(element, mode);
  },
  updateConfig: function (option) {
    store.dispatch(initApp(option));
  },
  initProtocol: function (custom_functions) {
    store.dispatch(initProtocol(custom_functions));
  },
  updateBottomButtons: function (data) {
    store.dispatch(updateBottomButtons(data));
  },
  loadData: function (messages) {
    store.dispatch(addMessages(messages));
  },
  chatRoomConnection: function (message) {
    store.dispatch(handleChatRoomConnection(message.action));
  },
  passiveReceiver: function (message) {
    store.dispatch(addMessages([message]));
  },
  appendMessages: function (messages) {
    store.dispatch(appendMessages(messages));
  },
  postMessage: function (message) {
    store.dispatch(postMessage(message));
  },
  sendMessage: function (message) {
    store.dispatch(sendMessage(message));
  },
  scrollToBottom: function () {
    store.dispatch(scrollToBottom());
  },
  showWaitCell: function () {
    store.dispatch(showWait());
  },
  hideWaitCell: function () {
    store.dispatch(hideWait());
  },
  getSystemMessages: function () {
    return store.getState().chatRoot.systemMessages;
  },
  setDefaultSystemMessages: function () {
    store.dispatch(setDefaultSystemMessages());
  },
  updateSystemMessages: function (systemMessages) {
    store.dispatch(updateSystemMessages(systemMessages));
  },
  updateTitle: function (title) {
    store.dispatch(updateTitle(title));
  },
  updatePlaceholder: function (placeholder) {
    store.dispatch(updatePlaceholder(placeholder));
  },
});
window.cu = cu;
